module.exports = __webpack_public_path__ + "img/IQ.a4c06608.png";